import { useState, useEffect } from "react";
import axios from "axios";
import retry from "async-retry";

import Input from "../Components/Input";
import Results from "../Components/Results";

// PL6Lt9p1lIRZ311J9ZHuzkR5A3xesae2pk playlist

const PlaylistPage = ({
  API_URL,
  audioRef,
  setDownloading,
  setTitle,
  setTotal,
  setProgress,
  setPosition,
  setCurrentId,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [videosList, setVideosList] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  useEffect(() => {
    if (audioRef && audioRef.current && videosList && videosList.length > 0) {
      const handleEnded = () => {
        if (currentIndex < videosList.length - 1) {
          downloadAndPLay({
            title: videosList[currentIndex + 1].title,
            timestamp: videosList[currentIndex + 1].duration.timestamp,
            id: videosList[currentIndex + 1].videoId,
          });
          setCurrentIndex(currentIndex + 1);
        }
      };
      let currentAudioRef = audioRef.current;
      currentAudioRef.addEventListener("ended", handleEnded);
      return () => {
        if (currentAudioRef) {
          currentAudioRef.removeEventListener("ended", handleEnded);
        }
      };
    }
    // eslint-disable-next-line
  }, [audioRef, videosList, currentIndex]);

  const preDownload = (id) => axios.get(API_URL + "/download/" + id);

  const downloadAndPLay = async ({ title, timestamp, id }) => {
    setTotal(timestamp);
    setDownloading(true);
    preDownload(id);
    (async () => {
      let data;
      retry(
        async () => {
          console.log("try");
          data = await axios.get(API_URL + "/ready/" + id);
          console.log("axios data", data);
          if (data.data.progress) {
            setPosition(null);
            setProgress(data.data.progress.slice(0, -3));
          }
          if (data.data.position) {
            setPosition(data.data.position);
          }
          if (!data.data.exists) {
            if (audioRef.current.paused) {
              audioRef.current.setAttribute(
                "src",
                "https://api-locktube.kazoo.agency/video/silence"
              );
              audioRef.current.play();
            }
            throw new Error("Retry");
          }
          if (data && data.data && data.data.exists) {
            setDownloading(false);
            setProgress(null);
            setPosition(null);
            setTotal(null);
            setTitle(title);
            audioRef.current.setAttribute("src", API_URL + "/video/" + id);
            audioRef.current.play();
            setCurrentId(id);
            preDownload(
              videosList[videosList.findIndex((el) => el.videoId === id) + 1]
                .videoId
            );
            return data;
          }
        },
        {
          retries: 300,
          randomize: false,
          factor: 1.1,
          minTimeout: 1000,
          maxTimeout: 10000,
        }
      );
    })();
  };

  return (
    <div>
      <Input
        label={"Playlist id or URL"}
        inputValue={inputValue}
        setInputValue={setInputValue}
        handleOnSubmit={(e) => {
          e.preventDefault();
          (async () => {
            let playlistId;
            if (inputValue.split("list=")[1]) {
              playlistId = inputValue.split("list=")[1];
            } else {
              playlistId = inputValue;
            }
            const data = await axios.get(API_URL + "/playlist/" + playlistId);
            setVideosList(data.data.videos);
          })();
        }}
      />
      {videosList ? (
        <Results
          results={videosList}
          handleOnResultClick={(el, index) => {
            downloadAndPLay({
              title: el.title,
              timestamp: el.duration.timestamp,
              id: el.videoId,
            });
            setCurrentIndex(index);
          }}
        />
      ) : null}
    </div>
  );
};
export default PlaylistPage;
